import { Action, Channel, EventChannel } from 'redux-saga';
import { actionChannel, call, put, race, select, take } from 'typed-redux-saga';
import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';
import createBroadcastEventChannel from '@spa/lib/store/sagas/createBroadcastEventChannel';
import { hydrateType } from '@spa/lib/store/HydrateAction';
import selectWishlists from '@spa/lib/store/wishlists/selectors/selectWishlists';
import { setWishlists } from '@spa/lib/store/wishlists/wishlistsSlice';

function* watchAndNotifyCurrentWishlistChanges(): Generator {
  const broadcastChannel: BroadcastChannel | undefined =
    BroadcastChannel !== undefined ? new BroadcastChannel('mul-wishlists') : undefined;

  const broadcastEventChannel: EventChannel<Array<StateWishlist>> =
    createBroadcastEventChannel<Array<StateWishlist>>(broadcastChannel);

  const requestChan: Channel<Action> = yield* actionChannel(['*']);
  let lastSessionWishlists: ReadonlyArray<StateWishlist> = [];

  while (true) {
    const { action, broadcast } = yield* race({
      action: take(requestChan),
      broadcast: take(broadcastEventChannel)
    });

    if (
      action !== undefined &&
      ((typeof action.type === 'string' && action.type.startsWith('wishlists/')) ||
        action.type === hydrateType)
    ) {
      const wishlists: ReadonlyArray<StateWishlist> = yield* select(selectWishlists);

      if (lastSessionWishlists !== wishlists) {
        const propagateChanges: boolean = shouldPropagateChanges(action);

        if (propagateChanges) {
          broadcastChannel?.postMessage(wishlists);
        }
      }

      lastSessionWishlists = wishlists;
    }

    yield* call(performBroadcast, broadcast, action);
  }
}

const shouldPropagateChanges = (action: Action): boolean =>
  setWishlists.match(action) ? action.payload.localChange : true;

function* performBroadcast(
  broadcast: Array<StateWishlist> | undefined,
  action: Action | undefined
): Generator {
  if (broadcast !== undefined && action === undefined) {
    yield* put(
      setWishlists({
        localChange: false,
        wishlists: broadcast
      })
    );
  }
}

export default watchAndNotifyCurrentWishlistChanges;
